import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ApprovalThumbPreview extends Component {
  constructor () {
    super()

    this.state = {
      w: 0,
      h: 0
    }

    this.onThumbLoad = this.onThumbLoad.bind(this)
  }
  onThumbLoad ({ target: img }) {
    this.setState({
      w: img.offsetWidth,
      h: img.offsetHeight
    })
  }
  render () {
    const { thumb } = this.props
    let { w, h } = this.state
    return (
      <div>
        <img onLoad={this.onThumbLoad} src={thumb.url} alt='' />
        <div className='thumb-size'>{w}x{h}</div>
      </div>
    )
  }
}

ApprovalThumbPreview.propTypes = {
  thumb: PropTypes.object.isRequired
}

export default ApprovalThumbPreview



// WEBPACK FOOTER //
// ./src/components/ApprovalThumbPreview.js